/* SuperDokan: cart presentation and submission guards. CartJS remains the cart owner. */
(function () {
  'use strict';
  if (window.sdMobileCartUI) return;
  window.sdMobileCartUI = true;
  function init() {
    var drawer = document.querySelector('#cart-drawer.sd-cart-drawer');
    var page = document.querySelector('[data-sd-cart-page]');
    if (!drawer && !page) return;
    var backdrop = document.querySelector('[data-sd-cart-backdrop]');
    var queueBusy = false, activeRequests = new Set(), failed = false;
    var pageStale = false, submitting = false, slow = false, slowTimer = 0;
    var submissionTimer = 0, wasOpen = false, previousFocus = null, boundAjax = false;
    var isArabic = /^ar(?:-|$)/i.test(document.documentElement.lang);
    var copy = isArabic ? {
      busy: 'جار تحديث السلة…', slow: 'التحديث يستغرق وقتاً أطول. راجع السلة قبل إتمام الطلب.',
      error: 'تعذر تأكيد التحديث. راجع السلة للتحقق من الكميات والأسعار.',
      dirty: 'تغيّرت الكميات. حدّث السلة لعرض المجموع الجديد.',
      stale: 'تم تعديل السلة. أعد تحميلها قبل إتمام الطلب.',
      invalid: 'أدخل كمية صحيحة: صفر أو أكثر.', terms: 'وافق على الشروط للمتابعة.',
      submit: 'جار الانتقال لإتمام الطلب…'
    } : {
      busy: 'Updating your cart…', slow: 'This is taking longer. Review your cart before checking out.',
      error: 'We could not confirm the update. Review your cart to check quantities and prices.',
      dirty: 'Quantities changed. Update cart to refresh these totals.',
      stale: 'Your cart changed. Refresh it before checking out.',
      invalid: 'Enter a whole-number quantity of zero or more.', terms: 'Please accept the terms to continue.',
      submit: 'Taking you to checkout…'
    };
    function busy() { return queueBusy || activeRequests.size > 0; }
    function status(container, message, isError) {
      if (!container) return;
      var note = container.querySelector('[data-sd-cart-status]');
      if (!note) return;
      note.textContent = message || '';
      note.hidden = !message;
      note.classList.toggle('sd-cart-status-error', !!isError);
    }
    function dirty() {
      return !!page && Array.from(page.querySelectorAll('[data-sd-initial-quantity]')).some(function (input) {
        return input.value !== input.dataset.sdInitialQuantity;
      });
    }
    function reflect() {
      var pending = busy();
      if (!pending) { window.clearTimeout(slowTimer); slowTimer = 0; slow = false; }
      else if (!slowTimer) {
        slowTimer = window.setTimeout(function () { slow = true; reflect(); }, 15000);
      }
      var message = failed ? copy.error : pending ? (slow ? copy.slow : copy.busy) : submitting ? copy.submit : '';
      status(drawer, message, failed);
      status(page, message || (pageStale ? copy.stale : dirty() ? copy.dirty : ''), failed || pageStale);
      if (drawer) {
        drawer.setAttribute('aria-busy', String(pending));
        drawer.querySelectorAll('[data-cart-update], [data-cart-remove]').forEach(function (control) {
          control.setAttribute('aria-disabled', String(pending || submitting));
        });
      }
      [drawer, page].forEach(function (container) {
        if (!container) return;
        var button = container.querySelector('input[name="checkout"]');
        if (button) {
          var blocked = pending || failed || submitting || (container === page && pageStale);
          button.dataset.sdCartBlocked = String(blocked);
          button.setAttribute('aria-disabled', String(blocked || button.disabled));
          /* Leave native disabled state, value, and name to the existing form/terms logic. */
        }
      });
      if (page) page.querySelectorAll('[data-sd-cart-review]').forEach(function (link) {
        link.hidden = !(pageStale || failed || slow);
      });
    }
    function cartEndpoint(settings) {
      try {
        var url = new URL(settings.url, window.location.href);
        return url.origin === window.location.origin && /\/cart(?:\/(?:add|change|update|clear))?\.js\/?$/.test(url.pathname);
      } catch (_) { return false; }
    }
    function mutationEndpoint(settings) {
      try { return /\/cart\/(?:add|change|update|clear)\.js\/?$/.test(new URL(settings.url, location.href).pathname); }
      catch (_) { return false; }
    }
    function cancelAutoClose() {
      if (drawer && drawer.classList.contains('active') && !document.body.classList.contains('showOverly')) {
        window.clearTimeout(window.drawerTimeout);
      }
    }
    function bindAjax() {
      if (boundAjax || !window.jQuery) return;
      boundAjax = true;
      var $doc = window.jQuery(document);
      $doc.on('cart.requestStarted.sdMobileCart', function () {
        queueBusy = true; failed = false; reflect();
      });
      $doc.on('cart.requestComplete.sdMobileCart', function () {
        queueBusy = false; reflect();
      });
      $doc.on('ajaxSend.sdMobileCart', function (_, xhr, settings) {
        if (!cartEndpoint(settings)) return;
        if (!busy()) failed = false;
        activeRequests.add(xhr); reflect();
      });
      $doc.on('ajaxError.sdMobileCart', function (_, xhr, settings) {
        if (cartEndpoint(settings)) { failed = true; reflect(); }
      });
      $doc.on('ajaxSuccess.sdMobileCart', function (_, xhr, settings) {
        if (!cartEndpoint(settings)) return;
        if (page && mutationEndpoint(settings)) pageStale = true;
        if (/\/add\.js\/?$/.test(new URL(settings.url, location.href).pathname)) cancelAutoClose();
      });
      $doc.on('ajaxComplete.sdMobileCart', function (_, xhr, settings) {
        if (!cartEndpoint(settings)) return;
        activeRequests.delete(xhr); reflect();
      });
    }
    function closeDrawer() { if (drawer) drawer.classList.remove('active'); }
    function drawerState() {
      if (!drawer) return;
      var open = drawer.classList.contains('active');
      drawer.inert = !open;
      drawer.setAttribute('aria-hidden', String(!open));
      if (backdrop) backdrop.hidden = !open;
      document.documentElement.classList.toggle('sd-cart-open', open);
      document.querySelectorAll('.header-cart').forEach(function (link) {
        link.setAttribute('aria-controls', 'cart-drawer');
        link.setAttribute('aria-expanded', String(open));
      });
      if (open && !wasOpen) {
        previousFocus = document.activeElement;
        cancelAutoClose();
        if (!document.body.classList.contains('showOverly')) {
          var close = drawer.querySelector('.close-cart');
          if (close) close.focus({preventScroll: true});
        }
      } else if (!open && wasOpen && previousFocus && previousFocus.isConnected &&
          (drawer.contains(document.activeElement) || document.activeElement === document.body)) {
        previousFocus.focus({preventScroll: true});
      }
      wasOpen = open;
    }
    function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : event.target.parentElement;
      if (!target) return;
      if (target.closest('[data-sd-cart-backdrop]') || (drawer && drawer.contains(target) && target.closest('.close-cart'))) {
        stop(event); closeDrawer(); return;
      }
      var action = target.closest('[data-cart-update], [data-cart-remove]');
      if (action && drawer && drawer.contains(action) && (busy() || submitting)) { stop(event); reflect(); return; }
      if (target.closest('#cartDWcheckout, #cartCheckout')) {
        var onPage = page && page.contains(target);
        if (busy() || failed || submitting || (onPage && pageStale)) { stop(event); reflect(); }
      }
    }, true);
    document.addEventListener('keydown', function (event) {
      if (!drawer || !drawer.classList.contains('active') || document.body.classList.contains('showOverly')) return;
      if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); return; }
      if (event.key !== 'Tab') return;
      var items = Array.from(drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]')).filter(function (item) {
        return !item.disabled && item.tabIndex >= 0 && item.getClientRects().length;
      });
      if (!items.length) { event.preventDefault(); drawer.focus(); return; }
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    });
    function validQuantities(form) {
      var bad = null;
      form.querySelectorAll('[data-sd-initial-quantity]').forEach(function (input) {
        var valid = /^\d+$/.test(input.value) && Number.isSafeInteger(Number(input.value));
        input.setAttribute('aria-invalid', String(!valid));
        if (!valid && !bad) bad = input;
      });
      if (bad) { status(page, copy.invalid, true); bad.focus(); }
      return !bad;
    }
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-sd-page-form], [data-sd-drawer-form]')) return;
      if (event.defaultPrevented) return;
      var onPage = form.hasAttribute('data-sd-page-form');
      var isCheckout = event.submitter ? event.submitter.name === 'checkout' : !onPage;
      if (busy() || (onPage && pageStale) || (isCheckout && (failed || submitting))) { stop(event); reflect(); return; }
      if (onPage && !validQuantities(form)) { stop(event); return; }
      if (!isCheckout) return;
      var terms = document.getElementById(onPage ? 'cartTearm' : 'cartDWtearm');
      if (terms && !terms.checked) { stop(event); status(onPage ? page : drawer, copy.terms, true); terms.focus(); return; }
      submitting = true; reflect();
      /* Keep the original POST and checkout submitter; never disable it before serialization. */
      Promise.resolve().then(function () {
        if (event.defaultPrevented) { submitting = false; reflect(); }
      });
      window.clearTimeout(submissionTimer);
      submissionTimer = window.setTimeout(function () { submitting = false; reflect(); }, 15000);
    }, true);
    ['cartTearm', 'cartDWtearm'].forEach(function (id) {
      var input = document.getElementById(id);
      if (!input) return;
      input.addEventListener('change', function () {
        var button = document.getElementById(id === 'cartTearm' ? 'cartCheckout' : 'cartDWcheckout');
        if (button) button.disabled = !input.checked;
        reflect();
      });
    });
    if (page) {
      page.addEventListener('input', reflect);
      page.addEventListener('change', reflect);
      page.addEventListener('click', function (event) {
        if (event.target.closest('.qtyBtn')) window.requestAnimationFrame(reflect);
      });
      var panel = page.querySelector('[data-sd-cart-summary]');
      if (panel && window.ResizeObserver) {
        function sizePanel() {
          page.style.setProperty('--sd-cart-panel-height', Math.ceil(panel.getBoundingClientRect().height) + 24 + 'px');
        }
        page.classList.add('sd-cart-ready');
        new ResizeObserver(sizePanel).observe(panel);
        sizePanel();
      }
    }
    if (drawer) new MutationObserver(drawerState).observe(drawer, {attributes: true, attributeFilter: ['class']});
    window.addEventListener('pageshow', function () { submitting = false; window.clearTimeout(submissionTimer); reflect(); drawerState(); });
    window.addEventListener('load', bindAjax, {once: true});
    bindAjax(); drawerState(); reflect();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
}());
